module.exports = __webpack_public_path__ + "img/honor-right-1-5.4c31be06.jpg";